import styled from '@emotion/styled';
import { Trans } from '@lingui/macro';
import { Text } from 'components/text/Text';

export const SelectedRowCount = ({
  rowSelectionCount,
  tableId,
}: {
  rowSelectionCount?: number;
  tableId?: string;
}) => {
  return (
    <StyledText data-testid={`table_${tableId}_selection_count`} variant="labelSm" weight="regular">
      <Bold>{rowSelectionCount}</Bold> <Trans>Selected</Trans>
    </StyledText>
  );
};

const StyledText = styled(Text)`
  color: ${p => p.theme.palette.text.tertiary};
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 4px;
  min-width: 98px;
  gap: 4px;
  white-space: nowrap;
`;

const Bold = styled.b`
  font-weight: 600;
  color: ${p => p.theme.palette.text.secondaryHover};
`;
